module.exports = __webpack_public_path__ + "assets/b26.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b26.png
// module id = 612
// module chunks = 0